import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import logo from "./images/tash logo no background.png";
import Navbar from "./components/Navbar";
import About from "./pages/About";
import AssessmentInformation from "./pages/AssessmentInformation";
import Location from "./pages/Location";
// import SubmitReferral from "./pages/SubmitReferral";
import Contact from "./pages/Contact";
import "./App.css";
// import { useState } from "react";


function App() {
  let title = false;
  return (
    <div className="App">
      <main>
        <Router>
            <div className="title">
              {title ? <p>Tash Work Assessments</p>
                :
                <div>
                  {/* <img src={logo} className="logo"  alt="Tash Work Assessments" /> */}
                  <Navbar />
                </div>
              }
            </div>
              <Routes>
                <Route path="/" element={<About />} />
                <Route path="/assessment-information" element={<AssessmentInformation />} />
                <Route path="/location" element={<Location />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
        </Router>
        {/* <img src={logo} className="temp" alt="Task Work Assessments"/> */}
        {/* <p className="center_text">
          Specializing in:
        </p>
        <br></br>
        <p className="center_text">
          Physical Capacity Evaluations 
        </p>
        <p className="center_text">
          Functional Capacity Evaluations
        </p>
        <p className="center_text">
          Work Capacity Evaluations 
        </p>
        <p className="center_text">
          Jobsite Assessments
        </p>
        <p className="center_text">
          Pre-employment testing.
        </p> */}
        

        {/* <p>
          Trevor Tash has been an Occupational Therapist with over 20 years’ experience working in the areas of Worker Rehabilitation, Inpatient Rehab, and Home Care.
        </p>
        <p>
          Tash Work Assessments specializes in Physical Capacity Evaluations (AKA: Functional Capacity Evaluations), Work Capacity Evaluations, Jobsite Assessments, and Pre-employment Screening Tests.
        </p>
        <p>
          At this time, we are not conducting PCEs for disability applications.
        </p>
        <p>
          Please contact us for additional information and pricing.
        </p> */}
        <div className="footer_color">
          <div className="footer">
            <p className="footer_text">
              Tash Work Assessments, LLC
            </p>
            <p className="footer_text">
              Ph/Txt: (503) 433-5123
            </p>
          </div>
          <div className="footer">

            <p className="footer_text">
              Fax: (503) 388-7373
            </p>
            <p className="footer_text">
              trevor@tashworkassessments.com
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
